import { createElementVNode as _createElementVNode, toDisplayString as _toDisplayString, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode } from "vue"

const _hoisted_1 = { class: "card mb-25 border-0 rounded-0 bg-white letter-spacing" }
const _hoisted_2 = { class: "card-body p-15 p-sm-20 p-md-25" }
const _hoisted_3 = { class: "custom-search" }
const _hoisted_4 = { class: "row" }
const _hoisted_5 = { class: "col-md-4" }
const _hoisted_6 = { class: "form-group" }
const _hoisted_7 = { class: "col-md-4" }
const _hoisted_8 = { class: "col-md-4" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_v_select = _resolveComponent("v-select")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      _createElementVNode("div", _hoisted_3, [
        _createElementVNode("div", _hoisted_4, [
          _createElementVNode("div", _hoisted_5, [
            _createElementVNode("div", _hoisted_6, [
              _cache[3] || (_cache[3] = _createElementVNode("label", null, "Agence :", -1)),
              _createVNode(_component_v_select, {
                class: "custom-select-height",
                modelValue: _ctx.Agency,
                "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((_ctx.Agency) = $event)),
                options: _ctx.AgencyList,
                label: "name",
                "update:modelValue": "handleAgencySelection"
              }, {
                option: _withCtx(({ name, nb_colis }) => [
                  _createElementVNode("span", null, _toDisplayString(name) + " - " + _toDisplayString(nb_colis) + " Colis", 1)
                ]),
                _: 1
              }, 8, ["modelValue", "options"])
            ])
          ]),
          _createElementVNode("div", _hoisted_7, [
            _cache[4] || (_cache[4] = _createElementVNode("label", null, "Livreur :", -1)),
            _createVNode(_component_v_select, {
              class: "custom-select-height",
              modelValue: _ctx.Livreur,
              "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => ((_ctx.Livreur) = $event)),
              options: _ctx.Livreurs,
              label: "name"
            }, {
              option: _withCtx(({ name, nb_colis }) => [
                _createElementVNode("span", null, _toDisplayString(name) + " - " + _toDisplayString(nb_colis) + " Colis", 1)
              ]),
              _: 1
            }, 8, ["modelValue", "options"])
          ]),
          _createElementVNode("div", _hoisted_8, [
            (_ctx.auth.can('ADD_BP_L'))
              ? (_openBlock(), _createElementBlock("button", {
                  key: 0,
                  style: {"margin-top":"1.2rem"},
                  class: "btn btn-primary",
                  onClick: _cache[2] || (_cache[2] = 
//@ts-ignore
(...args) => (_ctx.AddPaymentNote && _ctx.AddPaymentNote(...args)))
                }, " Ajouter "))
              : _createCommentVNode("", true)
          ])
        ])
      ])
    ])
  ]))
}